import { useMemo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPromosDataState, selectReferrerPromo } from '../state';

const useReferrerPromo = () => {
  const referrerPromo = useSelector(selectReferrerPromo);
  const promosDataState = useSelector(selectPromosDataState);
  const returnObj = useMemo(
    () => ({
      referrerPromo,
      promosDataState,
    }),
    [referrerPromo, promosDataState],
  );

  return returnObj;
};

export default useReferrerPromo;
